import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { constants } from '@hero/configs';
import { useQueries } from '@hero/hooks';

import { CustomFilter } from '../CustomFilter';

import { CustomMenuList } from './CustomMenuList';
import { CustomOption } from './CustomOption';
import { CustomValueContainer } from './CustomValueContainer';

function PriceFilter() {
  const { t } = useTranslation();
  const { queries, addNewQueries } = useQueries();
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [selectRef, setSelectRef] = useState();

  const options = useMemo(() => {
    return constants.products.filter.priceRange.map(pr => ({
      label: pr.label,
      value: {
        minPrice: pr.min,
        maxPrice: pr.max
      }
    }));
  }, [constants.products.filter.priceRange]);

  const [prices, setPrices] = useState([]);

  useEffect(() => {
    const timeoutOperation = setTimeout(() => {
      const option = options.find(
        o =>
          o.value.minPrice === Number(queries.minPrice) ||
          o.value.maxPrice === Number(queries.maxPrice)
      );

      setPrices(option || []);

      if (queries.minPrice) setMinPrice(queries.minPrice || null);
      if (queries.maxPrice) setMaxPrice(queries.maxPrice || null);
    }, 1000);

    return () => clearTimeout(timeoutOperation);
  }, [queries.minPrice, queries.maxPrice]);

  return (
    <CustomFilter
      size="md"
      selectRef={setSelectRef}
      creatable={false}
      placeholder={t('price')}
      options={options}
      closeMenuOnSelect={false}
      styles={{
        option: () => ({
          marginBottom: 4,
          padding: 4,
          height: 32,
          textDecoration: 'underline'
        }),
        singleValue: () => ({
          fontWeight: 700
        })
      }}
      selectedOption={prices}
      minPrice={minPrice}
      maxPrice={maxPrice}
      onMinPriceChange={e => {
        if (prices?.length) selectRef.onChange(undefined, { action: 'clear' });
        setMinPrice(e.target.value);
        setPrices([]);
      }}
      onMaxPriceChange={e => {
        if (prices?.length) selectRef.onChange(undefined, { action: 'clear' });
        setMaxPrice(e.target.value);
        setPrices([]);
      }}
      onApply={() => {
        addNewQueries({ ...queries, minPrice, maxPrice });
      }}
      isMulti={false}
      components={{
        MenuList: CustomMenuList,
        Option: CustomOption,
        ValueContainer: CustomValueContainer
      }}
      menuWidth="300px"
      onChange={option => {
        setMinPrice(option?.value?.minPrice || '');
        setMaxPrice(option?.value?.maxPrice || '');
        setPrices(option);
      }}
      filterOption={() => true}
      controlWidth={160}
    />
  );
}

export { PriceFilter };
